import { useTranslation } from "react-i18next";

import { useJsonApi } from "@/modules/api/hooks/useJsonApi";
import { useMutation } from "@/modules/api/hooks/useMutation";
import { apiErrorValidate } from "@/modules/api/utils/apiErrorValidate";
import { signOutMutation } from "@/modules/auth/api/mutations/signOut/signOutMutation";
import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";

const translationNamespace = "apiMessages/useSignOutMutation";

export const useSignOutMutation = () => {
  const auth = useAuthContext();
  const jsonApi = useJsonApi();
  const { t } = useTranslation(translationNamespace);

  return useMutation([signOutMutation.name], {
    mutationFn: signOutMutation(jsonApi),
    onSuccess: () => {
      auth.signOut();
    },
    onError: (error) => {
      apiErrorValidate(error, {
        401: {
          UNAUTHORIZED: t("Something went wrong, please refresh the page"),
        },
      });
    },
    retry: false,
  });
};
